module.exports = "<p>\n  barbers works!\n</p>\n"